// Register the Casanéo PWA service worker.
// Only registers in production builds served over HTTPS (or on localhost).
export function registerServiceWorker() {
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  const isLocalhost =
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1";
  const isSecure = window.location.protocol === "https:" || isLocalhost;
  if (!isSecure) return;

  // Avoid running under CRA dev server (webpack HMR) which conflicts with SW cache.
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        // Auto-update on new SW
        registration.onupdatefound = () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (
              installing.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              // New content available — activate immediately on next reload
              installing.postMessage({ type: "SKIP_WAITING" });
            }
          };
        };
      })
      .catch(() => {
        /* silent: SW is a progressive enhancement */
      });
  });
}
